/** @format */
import dayjs from 'dayjs';
import { useState, useEffect } from 'react';
import FormControl from '@mui/material/FormControl';
import NativeSelect from '@mui/material/NativeSelect';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import Slider from '@mui/material/Slider';

const filterVariants = [
  {
    type: 'text',
    operations: ['contains', 'not contains', 'is', 'is not'],
    key: '',
    value: '',
  },
  {
    type: 'numeric',
    min: 0,
    max: Infinity,
  },
  {
    type: 'date',
    format: 'yyyy-mm-dd',
    start: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
    end: dayjs().format('YYYY-MM-DD'),
    selectedRange: [
      dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
      dayjs().format('YYYY-MM-DD'),
    ],
  },
  {
    type: 'select',
    options: [],
    selected: '',
    //{value: 'value', label: 'label'}
  },
  {
    type: 'multi-select',
    options: [],
    selected: [],
    //{value: 'value', label: 'label'}
  },
  {
    type: 'duration',
    format: 'hh:mm',
    inputUnits: 'seconds',
    min: 0,
    max: Infinity,
    selectedRange: [0, Infinity],
  },
];

function secondsToHHmm(d) {
  d = Number(d);
  var h = Math.floor(d / 3600);
  var m = Math.floor((d % 3600) / 60);

  var hDisplay = h > 0 ? (h <= 9 ? '0' + h : h) + ':' : '00:';
  var mDisplay = m > 0 ? (m <= 9 ? '0' + m : m) : '00';

  return hDisplay + mDisplay;
}

function FilterInput({
  variant,
  filter,
  setFilter,
  column,
  selectedOperation,
  setSelectedOperation,
  selectedValue,
  setSelectedValue,
  selectedRange,
  setSelectedRange,
  selectedDateRange,
  setSelectedDateRange,
  selectedDurationRange,
  setSelectedDurationRange,
}) {
  switch (variant.type) {
    case 'text':
      return (
        <Box sx={{ display: 'flex', flexDirection: 'row', m: '2%' }}>
          <Typography sx={{ lineHeight: '5' }}>{column.label}</Typography>
          <FormControl
            required
            fullWidth
            sx={{
              p: '2%',
              mx: '2%',
            }}
          >
            <InputLabel
              variant="standard"
              htmlFor="select-available-paring-model-filter-controlled-native"
              size="large"
            >
              Select an operation
            </InputLabel>
            <NativeSelect
              defaultValue={selectedOperation ? selectedOperation : ''}
              onChange={(event) => {
                // setSelectedModel(event.target.value);
                setSelectedOperation(event.target.value);
              }}
              inputProps={{
                name: 'Select a column',
                id: 'select-available-paring-model-filter-controlled-native',
              }}
            >
              <option aria-label="None" value="" />
              {variant.operations?.map((op, i) => {
                return (
                  <option key={op + i} value={op}>
                    {op}
                  </option>
                );
              })}
            </NativeSelect>
          </FormControl>
          <TextField
            id="outlined-basic"
            label=""
            variant="outlined"
            value={selectedValue}
            onChange={(event) => {
              setSelectedValue(event.target.value);
            }}
          />
        </Box>
      );
    case 'numeric':
      //Get extent of column
      return (
        <Box
          sx={{
            backgroundColor: '#e0e0e0',
            mt: '30px',
            //   p: '2%',
            px: '4%',
            borderRadius: '6px',
            minHeight: '50px',
          }}
        >
          <FormControl required fullWidth>
            <Slider
              value={selectedRange ? selectedRange : [0, 100]}
              getAriaLabel={() => 'Numeric Filter Range Selector'}
              valueLabelDisplay="on"
              //   marks={marks}
              min={column.filter.min}
              max={column.filter.max}
              //   max={marks.length - 1}
              onChange={(event, newValue, activeThumb) => {
                if (!Array.isArray(newValue)) {
                  return;
                }

                setSelectedRange(newValue);
              }}
            />
          </FormControl>
          <Typography gutterBottom>Select a range</Typography>
        </Box>
      );
    case 'date':
      let start = dayjs(column.filter.min);
      let end = dayjs(column.filter.max);
      return (
        <Box
          sx={{
            backgroundColor: '#e0e0e0',
            mt: '30px',
            //   p: '2%',
            px: '4%',
            borderRadius: '6px',
            minHeight: '50px',
          }}
        >
          <FormControl required fullWidth>
            <Slider
              value={
                selectedDateRange
                  ? selectedDateRange
                  : [0, end.diff(start, 'day')]
              }
              getAriaLabel={() => 'Numeric Filter Range Selector'}
              valueLabelDisplay="on"
              valueLabelFormat={(value) => {
                // console.log(value);
                let label = dayjs(column.filter.min)
                  .add(value, 'day')
                  .format('MM/DD');
                return label;
              }}
              //   marks={marks}
              min={0}
              max={end.diff(start, 'day')}
              //   min={}
              //   max={}
              onChange={(event, newValue, activeThumb) => {
                if (!Array.isArray(newValue)) {
                  return;
                }

                setSelectedDateRange(newValue);
              }}
            />
          </FormControl>
          <Typography gutterBottom>Select a date range</Typography>
        </Box>
      );
    case 'select':
      return (
        <div>
          <TextField id="outlined-basic" label="Outlined" variant="outlined" />
        </div>
      );
    case 'multi-select':
      return (
        <div>
          <TextField id="outlined-basic" label="Outlined" variant="outlined" />
        </div>
      );
    case 'duration':
      return (
        <Box
          sx={{
            backgroundColor: '#e0e0e0',
            mt: '30px',
            //   p: '2%',
            px: '4%',
            borderRadius: '6px',
            minHeight: '50px',
          }}
        >
          <FormControl required fullWidth>
            <Slider
              value={
                selectedDurationRange
                  ? selectedDurationRange
                  : [dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
              }
              getAriaLabel={() => 'Duration Filter Range Selector'}
              getAriaValueText={(value) => secondsToHHmm(value)}
              valueLabelDisplay="on"
              valueLabelFormat={(value) => secondsToHHmm(value)}
              //   marks={marks}
              min={column.filter.min}
              max={column.filter.max}
              //   max={marks.length - 1}
              onChange={(event, newValue, activeThumb) => {
                if (!Array.isArray(newValue)) {
                  return;
                }

                setSelectedDurationRange(newValue);
              }}
            />
          </FormControl>
          <Typography gutterBottom>Select a duration range</Typography>
        </Box>
      );
    default:
      return <div>Invalid Filter Type</div>;
  }
}

function FilterDialog({ columns, filters, setFilters, open, setOpen }) {
  let [selectedColumn, setSelectedColumn] = useState(columns[0]);
  let [selectedOperation, setSelectedOperation] = useState('is');
  let [selectedValue, setSelectedValue] = useState('');
  let [selectedRange, setSelectedRange] = useState([0, 100]);
  let [selectedDateRange, setSelectedDateRange] = useState([0, 1]);
  let [selectedDurationRange, setSelectedDurationRange] = useState([0, 10000]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleApplyFilter = () => {
    let newFilters = [...filters];
    let newFilter = {
        col: selectedColumn,
        isSet: true,
      },
      newOperation = selectedOperation,
      newValue = selectedValue,
      newRange = selectedRange,
      newDateRange = selectedDateRange,
      newDurationRange = selectedDurationRange;
    switch (selectedColumn.filter.type) {
      case 'text':
        newFilter.type = 'text';
        newFilter.operation = newOperation;
        newFilter.value = newValue;
        break;
      case 'numeric':
        newFilter.type = 'numeric';
        newFilter.range = newRange;
        break;
      case 'date':
        newFilter.type = 'date';
        newFilter.range = newDateRange;
        break;
      case 'duration':
        newFilter.type = 'duration';
        newFilter.range = newDurationRange;
        break;
      default:
        break;
    }
    let index = newFilters.findIndex(
      (filter) => filter.col.id === selectedColumn.id
    );
    if (index === -1) {
      newFilters.push(newFilter);
    } else {
      newFilters[index] = newFilter;
    }
    // console.log(newFilters);

    setFilters(newFilters);
    setOpen(false);
  };

  useEffect(() => {
    if (!selectedColumn) return;
    if (selectedColumn.filter.isSet) {
      switch (selectedColumn.filter.type) {
        case 'text':
          setSelectedOperation(
            filters?.find((filter) => filter?.col.id === selectedColumn.id)
              ?.operation
          );
          setSelectedValue(
            filters?.find((filter) => filter?.col.id === selectedColumn.id)
              ?.value
          );
          break;
        case 'numeric':
          setSelectedRange(
            filters?.find((filter) => filter?.col.id === selectedColumn.id)
              ?.range
          );
          break;
        case 'date':
          setSelectedDateRange(
            filters?.find((filter) => filter?.col.id === selectedColumn.id)
              ?.range
          );
          break;
        case 'duration':
          setSelectedDurationRange(
            filters?.find((filter) => filter?.col.id === selectedColumn.id)
              ?.range
          );
          break;
        default:
          break;
      }
    } else {
      switch (selectedColumn.filter.type) {
        case 'text':
          setSelectedOperation('is');
          setSelectedValue('');
          break;
        case 'numeric':
          setSelectedRange([
            selectedColumn.filter.min,
            selectedColumn.filter.max,
          ]);
          break;
        case 'date':
          let start = dayjs(selectedColumn.filter.min);
          let end = dayjs(selectedColumn.filter.max);
          let days = end.diff(start, 'day');
          setSelectedDateRange([0, days]);
          break;
        case 'duration':
          setSelectedDurationRange([
            selectedColumn.filter.min,
            selectedColumn.filter.max,
          ]);
          break;
        default:
          break;
      }
    }
  }, [selectedColumn]);

  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Setup Filters</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please select the header you want to setup a filter for.
          </DialogContentText>
          <FormControl
            required
            fullWidth
            sx={{
              p: '2%',
            }}
          >
            <InputLabel
              variant="standard"
              htmlFor="select-available-paring-model-filter-dialog-controlled-native"
              size="large"
            >
              Select a column
            </InputLabel>
            <NativeSelect
              value={selectedColumn ? selectedColumn.id : ''}
              onChange={(event) => {
                // setSelectedModel(event.target.value);
                let selectedColumn = columns.find(
                  (col) => col.id === event.target.value
                );
                setSelectedColumn(selectedColumn);
              }}
              inputProps={{
                name: 'Select a column',
                id: 'select-available-paring-model-filter-dialog-controlled-native',
              }}
            >
              <option aria-label="None" value="" />
              {columns?.map((col, i) => {
                return (
                  <option key={col.id + i} value={col.id}>
                    {col.label}
                  </option>
                );
              })}
            </NativeSelect>
          </FormControl>
          {selectedColumn ? (
            <FilterInput
              selectedOperation={selectedOperation}
              setSelectedOperation={setSelectedOperation}
              selectedValue={selectedValue}
              setSelectedValue={setSelectedValue}
              selectedRange={selectedRange}
              setSelectedRange={setSelectedRange}
              selectedDateRange={selectedDateRange}
              setSelectedDateRange={setSelectedDateRange}
              selectedDurationRange={selectedDurationRange}
              setSelectedDurationRange={setSelectedDurationRange}
              variant={filterVariants.find(
                (variant) => variant.type === selectedColumn.filter.type
              )}
              filter={filters?.find(
                (filter) => filter?.column === selectedColumn
              )}
              setFilter={setFilters}
              column={selectedColumn}
            />
          ) : (
            <div></div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleApplyFilter}>Apply Filter</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default FilterDialog;
